module.exports = {"data":{"site":{"siteMetadata":{"algolia":{"appId":"M6UTFZCWVO","searchOnlyApiKey":"476b740fa66a19ef00a684ce8319c5dd","indexName":"MartianRace"},"facebook":{"appId":"1184472234930745"}}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/search.json
// module id = 813
// module chunks = 254572558124955